<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style rel="stylesheet/less" lang="less">
  @import "~assets/lib/css/animations.css";
  @import "~assets/lib/css/swiper-3.4.0.min.css";
  @import "~assets/css/less.less";

  *{margin:0;padding:0;}
  body{
    font-family: Verdana, Arial, Helvetica, "微软雅黑", "microsoft yahei", sans-serif;
    font-size:32/@rem;
    color: #5C6066;
    min-width:1200px;
  }
  a{text-decoration: none;}
  li{list-style: none;}
  .center{width:1200px; margin:0 auto;}


  //响应式手机端
  @media (max-width: @maxwidth) {
    body{min-width: inherit;}
    .center{max-width:100%; margin:0 auto; height:100%;}
  }
</style>



// WEBPACK FOOTER //
// App.vue?757bf03c